import digitalData from 'digital-data';

export const videoPlayer = () => {
  const analyticsEvent = {
    category: {
      primaryCategory: 'button submission',
    },
    eventInfo: {},
    video: {},
  };

  window.LIFE_CYCLE_EVENT_BUS.on('video-player.start', ({ output = {} }) => {
    const { videoId = '', videoName = '', experienceName = '' } = output;
    analyticsEvent.eventInfo.eventName = 'video start';

    analyticsEvent.video.name = videoName;
    analyticsEvent.video.id = videoId;

    switch (experienceName) {
    case 'article':
      analyticsEvent.video.type = output.articleType;
      break;
    default:
      analyticsEvent.video.type = '';
      break;
    }

    digitalData.event.push(analyticsEvent);
  });
  window.LIFE_CYCLE_EVENT_BUS.on('video-player.complete', ({ output }) => {
    const { videoId = '', videoName = '', experienceName = '' } = output;
    analyticsEvent.eventInfo.eventName = 'video complete';

    analyticsEvent.video.name = videoName;
    analyticsEvent.video.id = videoId;

    switch (experienceName) {
    case 'article':
      analyticsEvent.video.type = output.articleType;
      break;
    default:
      analyticsEvent.video.type = '';
      break;
    }

    digitalData.event.push(analyticsEvent);
  });
};
